import { render, staticRenderFns } from "./PageHelpIndex.vue?vue&type=template&id=87224fa8&"
import script from "./PageHelpIndex.vue?vue&type=script&lang=js&"
export * from "./PageHelpIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports